import React from 'react';

import { OPComponent } from '../components';
import ResidentForm from './resident_form';

import { SUCCESS } from '../../actions/statusTypes';

export default class CaseFieldsEmployer extends OPComponent {
  constructor(props) {
    super(props);

    if (props.editingCase) {
      let { caseId, name, patientName, patientEmail, description, ailment, roleId, timeZone } =
        props.editingCase;

      this.state = {
        caseId,
        name,
        patientName,
        patientEmail,
        description,
        ailment,
        roleId,
        timeZone: timeZone || 'America/Los_Angeles',
      };
      this._storeOrigValsFromState();
    } else {
      this.state = {
        caseId: null,
        name: null,
        patientName: null,
        patientEmail: null,
        description: null,
        roleId: 1,
      };
    }
    this._formRef = React.createRef();
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.status === SUCCESS && prevProps.status !== SUCCESS) {
      this._storeOrigValsFromState();
      this.props.onSave();
    }
  }

  _storeOrigValsFromState() {
    this._origVals = {
      ...this.state,
    };
  }

  needsSaving() {
    if (!this.props.editingCase) return true;

    let needsSave = false;
    for (var key in this.state) {
      needsSave = needsSave || this.state[key] !== this._origVals[key];
      if (needsSave) break;
    }

    return needsSave;
  }

  submit = () => {
    if (!this.needsSaving()) {
      this.props.onSave();
      return true;
    }

    const formIsValid = this._formRef.current?.validate();
    if (!formIsValid) {
      return false;
    }

    let caseObj = {
      name: this.state.name,
      patientName: this.state.patientName || this.state.name,
      description: this.state.description || this.state.name,
      roleId: this.state.roleId,
      ailment: this.state.ailment || null,
    };

    if (this.state.caseId != null) {
      caseObj.timeZone = this.state.timeZone;
      this.props.updateCase(this.state.caseId, caseObj);
    } else {
      const employer = this.props.currentEmployer;
      const employerId = employer ? employer.employerId : null;
      this.props.addCase(caseObj, employerId);
    }

    return true;
  };

  handleChangeValue = (val) => {
    this.setState(val);
  };

  render() {
    const { componentId, editable } = this.props;

    return (
      <ResidentForm
        ref={this._formRef}
        editable={editable}
        componentId={componentId}
        caseId={this.state.caseId}
        name={this.state.name}
        handleChangeValue={this.handleChangeValue}
      />
    );
  }
}
